import { inject } from '@angular/core'
import { Route } from '@angular/router'
import {
    authGuard,
    AuthStateService,
    groupTypeGuard,
    permissionGuard,
} from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type SettingsRoutes = {
    settings: Route
    settingsClient: Route
}

export const settingsRoutes: SettingsRoutes = {
    settings: {
        path: 'dashboard/settings',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            groupTypeGuard({
                groupType: 'vendor',
                redirectTo: ['/dashboard/client/settings'],
            }),
            permissionGuard([PERMISSIONS.settings.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-settings/page-settings').then(
                (m) => m.PageSettingsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
        children: [
            {
                path: '',
                canMatch: [
                    () => {
                        const authState = inject(AuthStateService)
                        return !authState.isOrdinaryStaff()
                    },
                ],
                loadComponent: () =>
                    import('../../main/settings/preferences/preferences.component').then(
                        (m) => m.PreferencesComponent,
                    ),
            },
            {
                path: '',
                canMatch: [
                    () => {
                        const authState = inject(AuthStateService)
                        return authState.isOrdinaryStaff()
                    },
                ],
                loadComponent: () =>
                    import('../page-profile/page-profile.component').then(
                        (m) => m.PageProfileComponent,
                    ),
            },
            {
                path: 'business-hours',
                canActivate: [
                    permissionGuard([PERMISSIONS.shop.write], {
                        redirectTo: ['/dashboard/settings'],
                    }),
                ],
                loadComponent: () =>
                    import('../../main/settings/business-hours/business-hours.component').then(
                        (m) => m.BusinessHoursComponent,
                    ),
            },
            {
                path: 'shop-details',
                canActivate: [
                    permissionGuard([PERMISSIONS.shop.write], {
                        redirectTo: ['/dashboard/settings'],
                    }),
                ],
                loadComponent: () =>
                    import('../../main/settings/shop-details/shop-details.component').then(
                        (m) => m.ShopDetailsComponent,
                    ),
            },
        ],
    },

    settingsClient: {
        path: 'dashboard/client/settings',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            groupTypeGuard({
                groupType: 'client',
                redirectTo: ['/dashboard/settings'],
            }),
        ],
        loadComponent: () =>
            import('../page-settings/page-settings').then(
                (m) => m.PageSettingsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.ClientDefault) },
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('../../main/settings/preferences/preferences.component').then(
                        (m) => m.PreferencesComponent,
                    ),
            },
        ],
    },
}
